import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2 as Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LockIcon from "@mui/icons-material/Lock";
import React, { useEffect, useState } from "react";
import AppMessage from "../../components/AppMessage/AppMessage";
import { useDispatch, useSelector } from "react-redux";
import { validate } from "validate.js";
import {
  changePassword,
  logout,
  resetStateAuth,
} from "../../app/slices/authSlice";

const ChangePasswordDialog = ({ isOpen, handleClose }) => {
  const { data, error, status } = useSelector(({ auth }) => auth.password);
  const { activeSession } = useSelector(({ auth }) => auth);

  const [response, setResponse] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [errors, setErrors] = useState([]);
  const dispatch = useDispatch();

  const passwordFormat = {
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/,
    message:
      "^Password should be at least 8 characters long, contain an uppercase letter, a lowercase  letter and a special character",
  };

  const schema = {
    currentPassword: {
      presence: { allowEmpty: false },
    },
    newPassword: {
      presence: { allowEmpty: false },
      format: passwordFormat,
    },
    confirmPassword: {
      presence: { allowEmpty: false },
      format: passwordFormat,
    },
  };

  //use effects
  useEffect(() => {
    dispatch(resetStateAuth(["password"]));
    return () => {
      dispatch(resetStateAuth(["password"]));
    };
  }, []);

  useEffect(() => {
    if (error) {
      setResponse({
        type: "error",
        message: error?.message || "An error occurred",
      });
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      setResponse({
        type: "success",
        message: data,
      });
      setTimeout(() => {
        dispatch(logout());
      }, 2000);
    }
  }, [data]);

  //methods
  const handleSubmit = () => {
    let _errors = validate(formValues, schema);
    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    dispatch(
      changePassword({
        user_id: activeSession?.user_id,
        currentPassword: formValues?.currentPassword,
        newPassword: formValues?.newPassword,
      })
    );
  };

  const handleChange = (e) => {
    const inputName = e?.target?.name;
    const inputValue = e?.target?.value;

    setFormValues({
      ...formValues,
      [inputName]: inputValue,
    });
  };

  //builders
  const BuildForm = () => {
    return (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            required
            variant="outlined"
            name="currentPassword"
            type="password"
            value={formValues?.currentPassword}
            onChange={handleChange}
            id="currentPassword"
            label="Current Password"
            error={errors["currentPassword"] ? true : false}
            helperText={
              errors["currentPassword"] ? errors.currentPassword[0] : null
            }
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            required
            variant="outlined"
            name="newPassword"
            type="password"
            value={formValues?.newPassword}
            onChange={handleChange}
            id="new-password"
            label="New Password"
            error={errors["newPassword"] ? true : false}
            helperText={errors["newPassword"] ? errors.newPassword[0] : null}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            required
            variant="outlined"
            name="confirmPassword"
            type="password"
            value={formValues?.confirmPassword}
            onChange={handleChange}
            id="confirm-password"
            label="Confirm Password"
            error={errors["confirmPassword"] ? true : false}
            helperText={
              errors["confirmPassword"] ? errors.confirmPassword[0] : null
            }
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth={"xs"}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <DialogTitle id="report-incident-header">CHANGE PASSWORD</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div className="mt-10">{BuildForm()}</div>
          <AppMessage
            onClose={() => {
              setResponse(null);
            }}
            isOpen={response !== null}
            message={response?.message}
            messageType={response?.type}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions id="report-incident-actions">
        {data === null && (
          <Button
            onClick={handleSubmit}
            style={{ minWidth: "unset" }}
            id="button-submit"
            disabled={false}
            variant="contained"
            color="primary"
            size="medium"
          >
            CHANGE
          </Button>
        )}
        <Button
          onClick={() => {
            handleClose();
          }}
          style={{ minWidth: "unset" }}
          id="button-closes"
          disabled={false}
          variant="contained"
          color="error"
          size="medium"
        >
          <CloseIcon />
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;
